import {get} from 'lodash';

export default (state = {}, {customer_id, data}: any) => {
  return {
    ...state,
    allWeightGraphData: {
      ...get(state, 'allWeightGraphData', {}),
      [customer_id]: data,
    },
  };
};
